import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import CopyIcon from './CopyIcon';
import { ReferenceButton, CopiedNote } from './ErrorBoundary.styled';
import { copyToClipboard, shortReference } from './ErrorFallback.helpers';

const COPIED_MS = 2000;

// The Sentry event id of the caught error, so a user reporting the problem can
// quote it and support can open that exact event. Copies the full id on click;
// the short ref stays readable, with a brief "Copied" beside it on success.
const ReferenceCode = ({ eventId }) => {
  const { t } = useTranslation();
  const [copied, setCopied] = useState(false);
  const mounted = useRef(true);
  const timer = useRef(null);

  useEffect(() => () => {
    mounted.current = false;
    clearTimeout(timer.current);
  }, []);

  const handleCopy = () => copyToClipboard(eventId).then((ok) => {
    if (!mounted.current || !ok) return;
    setCopied(true);
    clearTimeout(timer.current);
    timer.current = setTimeout(() => { if (mounted.current) setCopied(false); }, COPIED_MS);
  });

  return (
    <ReferenceButton type="button" onClick={handleCopy} title={t('common.errorBoundary.copyReference', { defaultValue: 'Copy the error reference' })}>
      {t('common.errorBoundary.reference', { defaultValue: 'Ref {{ref}}', ref: shortReference(eventId) })}
      <CopyIcon />
      {copied && <CopiedNote>{t('common.errorBoundary.copied', { defaultValue: 'Copied' })}</CopiedNote>}
    </ReferenceButton>
  );
};

ReferenceCode.propTypes = {
  eventId: PropTypes.string.isRequired
};

export default ReferenceCode;
